// Allowed file size limits
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB
